<template>
  <v-card hover>
    <v-card-title>
      <v-icon left>person</v-icon>
    </v-card-title>
    {{getPrimaryId.value}}
  </v-card>
</template>
<script>
export default {
  props: ['patient'],
  computed: {
    getPrimaryId () {
      return this.patient.identifier[1]
    }
  }
}
</script>
